import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { addClass, removeClass } from '@utils/classHandler';

import './PhotoScrollerList.scss';

const INITIALLY_LOADED_ITEMS = 2;
const TIME_TO_CHANGE_SLIDE = 2000;
const TIME_TO_REMOVE_FADE_OUT_CLASS = 1000;

const PhotoScrollerList = ({ photoList }) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const photoListRef = Array.from({ length: photoList.length }, () => useRef());

  const [currentPhoto, setCurrentPhoto] = useState(0);
  const currentPhoroRef = useRef(currentPhoto);
  currentPhoroRef.current = currentPhoto;

  const [previousItem, setPreviousItem] = useState(0);
  const previousItemRef = useRef(previousItem);
  previousItemRef.current = previousItem;

  const [itemPositionLoad, setItemPositionLoad] = useState(
    INITIALLY_LOADED_ITEMS
  );
  const itemPositionLoadRef = useRef(itemPositionLoad);
  itemPositionLoadRef.current = itemPositionLoad;

  const fadeOutTimeoutRef = useRef();

  useEffect(() => {
    const photoTimer = setInterval(() => {
      setPreviousItem(currentPhoroRef.current);
      setCurrentPhoto((currentPhoroRef.current + 1) % photoList.length);
      if (itemPositionLoadRef.current < photoList.length) {
        setItemPositionLoad(itemPositionLoadRef.current + 1);
      }
    }, TIME_TO_CHANGE_SLIDE);
    return () => {
      clearInterval(photoTimer);
      clearTimeout(fadeOutTimeoutRef.current);
    };
  }, [photoList.length]);

  useEffect(() => {
    if (previousItem !== currentPhoto) {
      addClass(
        photoListRef[previousItem].current,
        'photo-scroller-list__item--fade-out'
      );
    }
    removeClass(
      photoListRef[previousItem].current,
      'photo-scroller-list__item--active'
    );
    fadeOutTimeoutRef.current = setTimeout(async () => {
      removeClass(
        photoListRef[previousItemRef.current].current,
        'photo-scroller-list__item--fade-out'
      );
    }, TIME_TO_REMOVE_FADE_OUT_CLASS);
    addClass(
      photoListRef[currentPhoto].current,
      'photo-scroller-list__item--active'
    );
  }, [currentPhoto, photoListRef, previousItem]);

  return (
    <div className="photo-scroller-list">
      {photoList.map(
        (photo, index) =>
          index < itemPositionLoad && (
            <div
              ref={photoListRef[index]}
              key={photo.description}
              className="photo-scroller-list__item"
            >
              <img
                src={photo.src}
                srcSet={photo.srcSet}
                alt={photo.description}
              />
            </div>
          )
      )}
    </div>
  );
};

PhotoScrollerList.propTypes = {
  photoList: PropTypes.arrayOf(
    PropTypes.shape({
      src: PropTypes.string,
      srcSet: PropTypes.string,
      description: PropTypes.string
    })
  ).isRequired
};

export default PhotoScrollerList;
